import React from 'react';

interface SpinnerProps {
  className?: string;
}

const Spinner = ({ className = '' }: SpinnerProps) => {
  return (
    <div
      className={`w-4 h-4 border-t-[2px] dark:border-white/50 border-black/30 rounded-full animate-spin ${className}`}
    ></div>
  );
};
export default Spinner;
